import { Color } from 'modules/styles/colors';
import { createSelector } from 'reselect';
import { RootState } from 'store/types';
import { appointmentDetailsFetchingSelector } from '../booking/selectors';
import { goalsLoadingState } from '../goals/selectors';
import { medicationsLoadingSelector } from '../medications/selectors';
import { profileSexSelector } from '../profile/selectors';
import { visitSummaryListLoadingSelector } from '../visitSummary/selectors';
import { recentVitalsLoadingSelector } from '../vitals/selectors';

export const healthRecordsLoadingSelector = createSelector(
  [
    visitSummaryListLoadingSelector,
    recentVitalsLoadingSelector,
    medicationsLoadingSelector,
    goalsLoadingState,
    appointmentDetailsFetchingSelector
  ],
  (loadingVisits, loadingVitals, loadingMedications, loadingGoals, loadingAppointment) => {
    return (
      loadingVisits || loadingVitals || loadingMedications || loadingGoals || loadingAppointment
    );
  }
);

export const malePreventativeCareMockRecords = [
  {
    title: 'Annual wellness visit',
    type: 'wellness',
    lastUpdated: '2017-10-06T22:36:32.000Z',
    referenceNumber: '12344',
    status: 'Schedule',
    statusColor: Color.primary
  },
  {
    title: 'Influenza (flu) Vaccine',
    type: 'fluShot',
    lastUpdated: '',
    referenceNumber: '12324',
    status: 'Schedule',
    statusColor: Color.primary
  },
  {
    title: 'Diabetes A1C management',
    type: 'diabetes',
    lastUpdated: '2017-11-06T22:36:32.000Z',
    referenceNumber: '12328',
    status: 'Up to date',
    statusColor: Color.gray
  }
];

export const femalePreventativeCareMockRecords = [
  {
    title: 'Annual wellness visit',
    type: 'wellness',
    lastUpdated: '2017-10-06T22:36:32.000Z',
    referenceNumber: '12344',
    status: 'Schedule',
    statusColor: Color.primary
  },
  {
    title: 'Influenza (flu) Vaccine',
    type: 'fluShot',
    lastUpdated: '',
    referenceNumber: '12324',
    status: 'Schedule',
    statusColor: Color.primary
  },
  {
    title: 'Mammogram',
    type: 'mammogram',
    lastUpdated: '2018-11-06T22:36:32.000Z',
    referenceNumber: '12322',
    status: 'Schedule',
    statusColor: Color.primary
  },
  {
    title: 'Cervical Cancer Screening',
    type: 'cervicalCancer',
    lastUpdated: '2018-11-06T22:36:32.000Z',
    referenceNumber: '12323',
    status: 'Schedule',
    statusColor: Color.primary
  },
  {
    title: 'Diabetes A1C management',
    type: 'diabetes',
    lastUpdated: '2017-11-06T22:36:32.000Z',
    referenceNumber: '12328',
    status: 'Schedule',
    statusColor: Color.primary
    // status: 'Up to date',
    // statusColor: Color.gray
  }
];

export const preventativeCareTopicsSelector = createSelector([profileSexSelector], sex => {
  if (sex === 'Male') {
    return malePreventativeCareMockRecords;
  }
  return femalePreventativeCareMockRecords;
});

export const healthRecordsSummaryIsDownloadingSelector = (state: RootState) =>
  state.healthRecords?.healthRecordsDownload?.isDownloading;
export const healthRecordsSummaryDownloadErrorSelector = (state: RootState) =>
  state.healthRecords?.healthRecordsDownload?.error;

/**
 * Share Health Record Summary
 */
export const shareHealthRecordSummarySelector = (state: RootState) =>
  state.healthRecords?.shareHealthRecordSummary;

export const shareHealthRecordSummarySendingSelector = createSelector(
  shareHealthRecordSummarySelector,
  shareHealthRecordSummary => shareHealthRecordSummary.isSendingHealthRecordSummary
);

export const shareHealthRecordSummaryDataSelector = createSelector(
  shareHealthRecordSummarySelector,
  shareHealthRecordSummary => shareHealthRecordSummary.sharedHealthRecordSummaryData
);
